import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Utensils, Leaf, ClipboardList, ShieldAlert } from 'lucide-react';
const features = [{
  icon: <Utensils className="w-10 h-10 text-earth-amber" data-id="element-34" />,
  title: 'RECETAS',
  subtitle: 'para todas las etapas',
  color: 'border-earth-amber/30'
}, {
  icon: <Leaf className="w-10 h-10 text-earth-green" data-id="element-35" />,
  title: 'ALIMENTACIÓN',
  subtitle: 'real, natural y equilibrada',
  color: 'border-earth-green/30'
}, {
  icon: <ClipboardList className="w-10 h-10 text-purple-400" data-id="element-36" />,
  title: 'GUÍAS PRÁCTICAS',
  subtitle: 'transición, organización y conservación',
  color: 'border-purple-400/30'
}, {
  icon: <ShieldAlert className="w-10 h-10 text-blue-400" data-id="element-37" />,
  title: 'ALIMENTOS',
  subtitle: 'tóxicos y no aptos listas completas',
  color: 'border-blue-400/30'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function FeaturesGrid() {
  return <section className="py-10 md:py-16 bg-dark-900 border-t border-dark-800" data-id="element-38">
      <div className="container mx-auto px-6" data-id="element-39">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-40">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className={`bg-dark-800 p-8 rounded-2xl border-t-4 ${feature.color} flex flex-col items-center text-center hover:bg-dark-800/80 transition-colors`} data-id="element-41">
              <div className="mb-4 p-4 bg-dark-900 rounded-full" data-id="element-42">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-43">
                {feature.title}
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-44">{feature.subtitle}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}